var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-center"},[_c('v-row',[_c('v-col',{staticClass:"pb-4 mb-0",attrs:{"offset-sm":"3"}},[_c('h2',[_vm._v("Nothing found for that query.")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }